// extracted by mini-css-extract-plugin
module.exports = {"root":"c6674c78","slides":"c9e09671"};